<div mat-dialog-content>
  <div class="layout-column align-middle bottom-banner spacer-vr-16">
    @if (!isUs) {
      <p class="mobile-copy spacer-bottom-8">The UK's #1 Kids' Debit Card & App</p>
    } @else {
      <p class="mobile-copy spacer-bottom-8">The GoHenry debit card & app</p>
    }
    <div class="layout-row align-center">
      @if (!isUs) {
        <p class="desktop-copy spacer-right-24">The UK's #1 Kids' Debit Card & App - Join Over 2 Million GoHenry Customers Today
        </p>
      } @else {
        <p class="desktop-copy spacer-right-24">The GoHenry debit card & app teaches kids about spending, saving, & more</p>
      }
      <a class="btn btn-outline" [href]="website + 'kids-debit-card/?blogcta=sticky-footer-whygohenry'" rel="nofollow"
        (click)="ctaClick('Why GoHenry','bottom-banner')">Why
      GoHenry</a>
      <div class="spacer-left-16"><a class="btn btn-primary " [href]="signup + '?blogcta=sticky-footer-startfreetrial'" rel="nofollow"
      (click)="ctaClick('Start free trial','bottom-banner')">Start free trial</a></div>
    </div>
  </div>
</div>
